export const localhomePageSectionsData = [
  {
    id: 76,
    date: '2020-08-13T19:29:04',
    date_gmt: '2020-08-13T19:29:04',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=home_page_sections&#038;p=76'
    },
    modified: '2023-05-15T20:45:17',
    modified_gmt: '2023-05-15T20:45:17',
    slug: 'story-section',
    status: 'publish',
    type: 'home_page_sections',
    link: 'https://cms.modlingroup.dbox.com/home_page_sections/story-section/',
    title: {
      rendered: 'Story Section'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      page_section: 'story',
      page_content: '<p>Differently. That’s how Adam D. Modlin does things.</p>\n<p>Instead of joining a big firm, he starts his own small—yet mighty— company. Instead of aiming for quick results, Adam nurtures lifelong relationships. Instead of boasting about jaw-dropping, history-making deals, he remains humble and discreet.</p>\n<p>In an industry full of characters from the Wild Wild West, Adam D. Modlin is the exception.  Creative. Calm.  And very connected. The ultimate listener, applying thoughtful finesse and out-of-the-box thinking to every transaction. Clients will attest, no detail is overlooked. No avenue left unexplored. No kindness spared. There’s no chest beating. No enormous ego. Just an extremely likeable man made up of brilliant traits. Polished but not pretentious. Powerful but not pompous. The self-made business magnate—who treats everyone like family.</p>\n<p>Luminary at commanding real estate’s most enviable deals, Adam D. Modlin continually makes high-profile history while surpassing his clients’ wildest dreams.  His portfolio of power moves – such as the $77.1 million sale of the single-family townhouse 14-16 East 67th Street and the $45 million sale of the San Remo Penthouse –has shattered New York’s real estate records.</p>\n<p>And the best is yet to come.</p>\n<p><img loading="lazy" width="1280" height="1024" class="aligncenter size-full wp-image-79" src="https://cms.modlingroup.dbox.com/wp-content/uploads/2020/08/Adam_Modlin_Story.jpg" alt="" srcset="https://cms.modlingroup.dbox.com/wp-content/uploads/2020/08/Adam_Modlin_Story.jpg 1280w, https://cms.modlingroup.dbox.com/wp-content/uploads/2020/08/Adam_Modlin_Story-300x240.jpg 300w, https://cms.modlingroup.dbox.com/wp-content/uploads/2020/08/Adam_Modlin_Story-768x614.jpg 768w" sizes="(max-width: 1280px) 100vw, 1280px" /></p>\n<p>Adam D. Modlin started Modlin Group in 1999. Without any experience working for a residential brokerage company, he was determined and motivated to create his own path in the industry. Before being able to afford an office, he got dressed every day with a suit and tie and walked down Madison Avenue to meet people. His office was the lobby of the Four Seasons Hotel on 57th Street. With a passion for life, enthusiasm, gratitude and love for New York City, he climbed the ladder of success in the industry the old fashion way…hard work.</p>\n<p>Today, <span dir="ltr" role="presentation">nearly</span> <span dir="ltr" role="presentation">twenty</span><span dir="ltr" role="presentation">&#8211;</span><span dir="ltr" role="presentation">five</span> <span dir="ltr" role="presentation">years later</span><span dir="ltr" role="presentation">, </span>Modlin Group is recognized as the leading boutique real estate agency in New York City.</p>\n<p><span dir="ltr" role="presentation">In early 2023, Modlin Group expanded to the Hamptons with the openin</span><span dir="ltr" role="presentation">g of a branch office in </span><span dir="ltr" role="presentation">Bridgehampton</span><span dir="ltr" role="presentation">, NY. The</span> <span dir="ltr" role="presentation">expansion</span> <span dir="ltr" role="presentation">followed the firm’s discreet facilitation of</span> <span dir="ltr" role="presentation">nearly $1 billion in </span><span dir="ltr" role="presentation">sales on the East End</span><span dir="ltr" role="presentation">,</span> <span dir="ltr" role="presentation">including the record</span><span dir="ltr" role="presentation">&#8211;</span><span dir="ltr" role="presentation">breaking</span> <span dir="ltr" role="presentation">sale of 90 Jule Pond Drive in Southampton </span><span dir="ltr" role="presentation">for $105 million</span><span dir="ltr" role="presentation">.</span></p>\n<p>Adam remains committed to high standards including discretion, integrity and reputation as the core values of the company. He covets his special relationships and always prioritizes people over the deal. With a discerning eye for aesthetics, Adam is known by his peers and clients for his thoughtful approach. He has developed a diverse clientele around the world that rely on his expertise, knowledge and discretion to advise and represent on complicated negotiations and transactions. He is known for representing clients in Private Equity/Hedge Funds, Banking, Real Estate, Entertainment, Media, Technology and Sports industries.</p>\n<p>Adam is an active member of REBNY-Real Estate Board of New York and a Founding Board member of NYRAC-New York Residential Agent Continuum.</p>\n<p>Adam is actively engaged in mentorship and philanthropic initiatives through a variety of organizations. A life-long New Yorker, he resides on the Upper East side with his wife and two daughters.</p>\n'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/home_page_sections/76'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/home_page_sections'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/home_page_sections'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=76'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  },
  {
    id: 77,
    date: '2020-08-13T19:48:20',
    date_gmt: '2020-08-13T19:48:20',
    guid: {
      rendered: 'https://cms.modlingroup.dbox.com/?post_type=home_page_sections&#038;p=77'
    },
    modified: '2022-12-01T14:01:19',
    modified_gmt: '2022-12-01T14:01:19',
    slug: 'supplementary-section',
    status: 'publish',
    type: 'home_page_sections',
    link: 'https://cms.modlingroup.dbox.com/home_page_sections/supplementary-section/',
    title: {
      rendered: 'Supplementary Section'
    },
    content: {
      rendered: '',
      protected: false
    },
    featured_media: 0,
    template: '',
    acf: {
      page_section: 'supplementary_section',
      page_content: '<h2>UNPARALLELED TAILORED SERVICES FOR SAVVY BUYERS AND SELLERS</h2>\n<p>Headed by Adam D. Modlin, Modlin Group leads Manhattan boutique firms in condominium, co-op, loft, and townhouse sales and leases. We have earned our reputation by adhering to the highest ethical standards, embodying best brokerage practices, and innovating in marketing. Modlin Group also has an extensive network, which allows us to identify choice properties before they are made available to the public. At our core, we are committed to pairing home and investment seekers to the perfect opportunity, and we welcome your inquiries.</p>\n'
    },
    _links: {
      self: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/home_page_sections/77'
        }
      ],
      collection: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/home_page_sections'
        }
      ],
      about: [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/types/home_page_sections'
        }
      ],
      'wp:attachment': [
        {
          href: 'https://cms.modlingroup.dbox.com/wp-json/wp/v2/media?parent=77'
        }
      ],
      curies: [
        {
          name: 'wp',
          href: 'https://api.w.org/{rel}',
          templated: true
        }
      ]
    }
  }
]
